import apiClient from './apiClient';

export interface QueryParams {
  report_type?: string;    // "bill", "date", "store", "product"
  date_from?: string;      // YYYY-MM-DD
  date_to?: string;        // YYYY-MM-DD
  store_from?: string;
  store_to?: string;
  product_from?: string;
  product_to?: string;
}

export interface ReportRow {
  FD150_01: string;      // bill no
  FD150_12: string;      // bill date
  FD150_13: string;      // store code
  FD150_14: string;      // store name
  FD151_10: string;      // product code 1
  FD151_11: string;      // product code 2
  product_code: string;  // concatenated
  FD151_12: string;      // product desc
  FD151_13: number;      // qty
  FD151_14: string;      // currency
  FD151_15: number;      // unit price
  FD151_16: number;      // qty2
  FD151_17: number;      // amount
}

export interface CurrencySummary {
  FD151_14: string;   // currency
  total_qty: number;
  total_amt: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  currency_summary: CurrencySummary[];
  message?: string;
}

export const d324Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d324/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/d324/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
